export const FETCH_BANNERS_REQUEST = "FETCH_BANNERS_REQUEST";
export const FETCH_BANNERS_SUCCESS = "FETCH_BANNERS_SUCCESS";
export const FETCH_BANNERS_FAILURE = "FETCH_BANNERS_FAILURE";

export const FETCH_TAMBOLA_REQUEST = "FETCH_TAMBOLA_REQUEST";
export const FETCH_TAMBOLA_SUCCESS = "FETCH_TAMBOLA_SUCCESS";
export const FETCH_TAMBOLA_FAILURE = "FETCH_TAMBOLA_FAILURE";